<template>
  <div>
    자동 로그아웃 되었습니다.
    <router-link :to="{path: '/', query: {redirectUri: $route.query.redirectUri}}">로그인 화면으로 이동</router-link>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'

export default {
  async created() {
    AuthService.signout()
    this.$router.push({ name: 'main' })
  }
}
</script>
